// @flow
import React, { PureComponent } from 'react';
import { Box } from 'gestalt';

type Props = {|
  duration: number, // in milliseconds
  finalProgress: number, // percentage from 0-100
  showLightGrayBackground?: boolean,
  rounded?: boolean,
|};

type State = {|
  startProgressBar: boolean,
|};

export default class AnimatingProgressBar extends PureComponent<Props, State> {
  state: State = {
    startProgressBar: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ startProgressBar: true });
    }, 0);
  }

  render() {
    const { duration, finalProgress, showLightGrayBackground, rounded } = this.props;
    return (
      <Box
        width="100%"
        color={showLightGrayBackground ? 'lightGray' : 'transparent'}
        shape={rounded ? 'rounded' : 'square'}
      >
        <Box
          color="red"
          height={6}
          shape="rounded"
          width={`${finalProgress}%`}
          dangerouslySetInlineStyle={{
            __style: {
              transform: this.state.startProgressBar ? 'scale(1, 1)' : 'scale(0, 1)',
              transformOrigin: 'left',
              transitionDuration: `${duration}ms`,
              transitionTimingFunction: 'ease-in',
            },
          }}
        />
      </Box>
    );
  }
}
